import * as Yup from 'yup';

import { MARGINS_OPTIONS, ORIENTATION_OPTIONS, PAGE_SIZE_OPTIONS, VIEW_MODE_OPTIONS } from './constants';

export const documentSettingsValidationSchema = Yup.object({
  viewMode: Yup.string()
    .oneOf(VIEW_MODE_OPTIONS.map((o) => o.value))
    .required(),
  pageSize: Yup.string()
    .oneOf(PAGE_SIZE_OPTIONS.map((o) => o.value))
    .required(),
  orientation: Yup.string()
    .oneOf(ORIENTATION_OPTIONS.map((o) => o.value))
    .required(),
  margins: Yup.string()
    .oneOf(MARGINS_OPTIONS.map((o) => o.value))
    .required(),
});
